module.exports = __webpack_public_path__ + "images/users/opt_in_modal/main_7cd0c30712a7b09bc18d51e1c5af1805.webp";